/*
 * @Author: jiangfeng
 * @Date: 2024-07-29 19:46:40
 * @LastEditTime: 2024-08-01 11:05:49
 * @LastEditors: jiangfeng
 * @FilePath: /governance-driver-projects/packages/acceptor-center/src/utils/data-center.js
 */
/* eslint-disable no-undef */
import {parseUrl} from '@didi/gpux-utils'

class DataCenter {
  constructor () {
    let queryObj = parseUrl(window.location.href, false)
    this.env = 'prod'
    if (queryObj.lang === 'zh' || queryObj.lang === 'zh-CN') {
      queryObj.lang = 'zh-CN'
    } else if (queryObj.lang === 'en' || queryObj.lang === 'en-US') {
      queryObj.lang = 'en-US'
    }
    this.lang = (queryObj && queryObj.lang) || 'zh-CN'
    this.global = false
  }
  /**
   * 设置公共参数(方法自定义的参数，会覆盖公共参数)
   * @param obj
   * {
   *  lang: 'en-US' // 'zh-CN', 'en-US'
   *  global: false,
   *  env: 'prod' // 'prod', 'dev'
   * }
   */
  setConfig (obj) {
    for (let key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key)) {
        this[key] = obj[key]
      }
    }
  }
  get (key) {
    return this[key]
  }
}
export default new DataCenter()
